<template>
	<div class="conMax">
		<div class="conTop">
			<p>{{this.conIng.name}}</p>
		</div>
		<div class="conMin">
			<div class="conBan">
				<img :src=this.conIng.image alt="">
			</div>
			<div class="conTet">
				<p>
					<icon></icon> 联系电话： {{this.conIng.phone}}
				</p>
				<p>
					<icon></icon> 联系地址： {{this.conIng._detailed_address}}
				</p>
				<p>
					公司简介： {{this.conIng.introduction}}
				</p>
			</div>
			<div class="conCar">
				<baidu-map v-bind:style="mapStyle" class="bm-view" ak="RG2BZ-XJGCF-FAIJ7-JKGWD-D6I5Z-M2B2I" :center="center" :zoom="zoom"
				 :scrollWheelZoom="true">
					<bm-view style="width: 100%; height:5rem;"></bm-view>
					<bm-marker :position="{lng: center.lng, lat: center.lat}" :dragging="true" animation="BMAP_ANIMATION_BOUNCE"
					 :scroll-wheel-zoom="true" @click="getClickInfo" @moving="syncCenterAndZoom" @moveend="syncCenterAndZoom" @zoomend="syncCenterAndZoom">
						<bm-label :content="conIng.name" :labelStyle="{color: 'red', fontSize : '24px'}" :offset="{width: -35, height: 30}" />
					</bm-marker>
				</baidu-map>
			</div>
		</div>
	</div>
</template>
<style>
	.serachinput {
		width: 300px;
		box-sizing: border-box;
		padding: 9px;
		border: 1px solid #dddee1;
		line-height: 20px;
		font-size: 16px;
		height: 100%;
		color: #333;
		position: relative;
		border-radius: 4px;
		-webkit-box-shadow: #666 0px 0px 10px;
		-moz-box-shadow: #666 0px 0px 10px;
		box-shadow: #666 0px 0px 10px;
	}


	.amap-demo {
		height: 300px;
	}

	.conMax {
		background-color: #ebebeb;
	}

	.conMin {
		width: 100%;
		background-color: white;
		margin-top: 15px;
		padding-top: 20px;
	}

	.conTop {
		height: 40px;
		width: 100%;
		margin: 0 auto;
		line-height: 40px;
		text-align: center;
		font-size: 16px;
		color: black;
		background-color: white;
	}

	.conBan {
		width: 95%;
		height: 4rem;
		margin: 0px auto;
		border-radius: 9px;
		background-color: darksalmon;
	}

	.conBan img {
		width: 100%;
		height: 100%;
	}


	.conTet {
		width: 95%;
		height: 1.5rem;
		padding: 0 10px;
		line-height: 0.6rem;
		background-color: white;
		margin: 0 auto;
	}

	.conCar {
		height: 5rem;
		width: 95%;
		margin: 20px auto;
		background-color: mistyrose;
	}
</style>


<!-- <script type="text/javascript" src="http://webapi.amap.com/maps?v=1.3&key=您申请的key值"></script> -->
<script>
	import {
		BaiduMap,
		BmControl,
		BmView,
		BmAutoComplete,
		BmLocalSearch,
		BmMarker
	} from 'vue-baidu-map';
	import {
		userCant
	} from "@api/user";

	export default {
		components: {
			BaiduMap,
			BmControl,
			BmView,
			BmAutoComplete,
			BmLocalSearch,
			BmMarker
		},
		data() {
			return {
				newArr: ['石家庄', '北京', '上海'],
				// alr:$route.query.id
				showMapComponent: this.value,
				keyword: '',
				mapStyle: {
					width: '100%',
					height: this.mapHeight + 'px'
				},
				center: {
					lng: 116.404,
					lat: 39.915
				},
				zoom: 15,
				conlId: this.$route.query.id,
				conIng: '',
				name: '',
			}
		},
		watch: {
			value: function(currentValue) {
				this.showMapComponent = currentValue
				if (currentValue) {
					this.keyword = ''
				}
			},

		},
		mounted() {
			this.userCan()
		},
		methods: {
			/***
			 * 地图点击事件。
			 */

			userCan() {
				userCant({
					id: this.conlId
				}).then(res => {
					this.center = {
						lat: res.data.data.latitude,
						lng: res.data.data.longitude,
					}
					this.conIng = res.data.data
					//	测试使用
					// this.center ={
					// 	lat :39.840843,
					// 	lng :114.588903,
					// }
					// 39.840843,
				})
			},

			getClickInfo(e) {
				this.center.lng = Number(this.conIng.longitude)
				this.center.lat = Number(this.conIng.latitude)
			},
			syncCenterAndZoom(e) {
				const {
					lng,
					lat
				} = e.target.getCenter()
				this.center.lng = Number(this.conIng.longitude)
				this.center.lat = Number(this.conIng.latitude)
				this.zoom = e.target.getZoom()
			},
		}
	}
</script>
